import * as React from 'react';
import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Icon from './Icon';
import Translate from './Translate';
import _FilterItemDropdown from './FilterItemDropdown';
import Badge from './Badge';
import ClearFilters from './ClearFilters';
import { FilterStore, DataStore } from '../stores';
import { observable, action, computed } from 'mobx';
import withFilter from './withFilter';

const FilterItemDropdown = withFilter(_FilterItemDropdown);

const FiltersWrapper = styled<any, any>('aside')`
    ${propStyles};
`;

FiltersWrapper.defaultProps = {
    display: 'flex',
    flexDirection: 'column',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'none none solid none',
    paddingY: 'md',
};

const FiltersWrapperInner = styled<any, any>('div')`
    ${propStyles};
`;

FiltersWrapperInner.defaultProps = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: ['stretch', 'flex-end'],
    flexDirection: ['column', 'row'],
    paddingY: 'md',
};

const FiltersHeader = styled<any, any>('h3')`
    ${propStyles};
    flex-shrink: 0;
`;

FiltersHeader.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'body',
    paddingX: 'lg',
};

const FiltersHeaderToggle = styled<any, any>('button')`
    ${propStyles};
    outline: none;
    cursor: pointer;
`;

FiltersHeaderToggle.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    flex: '1 0 auto',
    fontFamily: 'heading',
    fontWeight: 'medium',
    fontSize: 'inherit',
    color: 'body',
    bgColor: 'transparent',
    borderStyle: 'none',
};

interface FiltersProps {
    theme?: { [property: string]: string | number };
    filterStore?: FilterStore;
    dataStore?: DataStore;
    isMobile: boolean;
}

@inject('filterStore')
@inject('dataStore')
@observer
class FiltersTop extends Component<FiltersProps> {
    @observable isFiltersOpen: boolean = this.filtersOpenDefault;

    // Default value for filtersOpen
    @computed
    get filtersOpenDefault(): boolean {
        return this.props.dataStore.config.filtersTopExpanded;
    }

    // At mobile size filters are always expandable, otherwise use config setting
    @computed
    get filtersTopExpandable(): boolean {
        return this.props.isMobile
            ? true
            : this.props.dataStore.config.filtersTopExpandable;
    }

    // Filters are always open when not expandable and above mobile size
    @computed
    get filtersOpen(): boolean {
        return !this.props.dataStore.config.filtersTopExpandable &&
            !this.props.isMobile
            ? true
            : this.isFiltersOpen;
    }

    @action
    toggleFilters = () => {
        this.isFiltersOpen = !this.isFiltersOpen;
    };

    render() {
        const { theme, filterStore } = this.props;
        const { filtersOpen, toggleFilters, filtersTopExpandable } = this;

        return (
            <FiltersWrapper
                className={filtersOpen ? 'open' : ''}
                {...theme.FiltersTopWrapper}
            >
                <FiltersHeader {...theme.FiltersTopHeader}>
                    <FiltersHeaderToggle
                        onClick={filtersTopExpandable ? toggleFilters : null}
                        {...theme.FiltersTopHeaderToggle}
                    >
                        {filtersTopExpandable && (
                            <Icon
                                fileName={
                                    filtersOpen
                                        ? 'FiltersTopHeaderToggleIconExpanded'
                                        : 'FiltersTopHeaderToggleIcon'
                                }
                                {...theme.FiltersTopHeaderToggleIcon}
                            />
                        )}
                        <Translate>Filters</Translate>
                        {filterStore.filtersActive && (
                            <Badge
                                marginX="sm"
                                bgColor="primary"
                                {...theme.FiltersToggleBadge}
                                {...theme.FiltersTopToggleBadge}
                            >
                                {filterStore.filtersCount}
                            </Badge>
                        )}
                    </FiltersHeaderToggle>
                    {filterStore.filtersActive && (
                        <ClearFilters
                            margin="0 0 0 auto"
                            theme={{
                                ...theme,
                                FiltersClearButton: theme.FiltersTopClearButton,
                                ClearFiltersIcon: theme.ClearFiltersTopIcon,
                            }}
                        />
                    )}
                </FiltersHeader>
                <FiltersWrapperInner
                    {...theme.FiltersTopWrapperInner}
                    display={filtersOpen ? 'flex' : 'none'}
                >
                    {filterStore.filters.map(filter => (
                        <FilterItemDropdown
                            key={filter.property}
                            filter={filter}
                        />
                    ))}
                </FiltersWrapperInner>
            </FiltersWrapper>
        );
    }
}

export default withTheme(FiltersTop);



// WEBPACK FOOTER //
// ./src/Components/FiltersTop.tsx